<section class="bfa-component-wrapper" *ngIf="data?.success; else noData">
	<dl-section-header [subTitle]="subTitle" [title]="title" [asOfDate]="asOfDate"></dl-section-header>
	<bfa-accordion>
		<ng-container *ngFor="let tab of data.tabs; index as idx">
			<accordion-panel [isCollapsed]="!tab?.displayConfig?.active" *ngIf="tab?.displayConfig?.visible && tab?.displayConfig?.isIterative">
				<header><ng-container *ngTemplateOutlet="accordionHeaderContent; context: { tab: tab }"></ng-container></header>
				<content *ngIf="tab.config && tab.config.id === 'eq.sleeve.characteristics'">
					<ng-container *ngIf="!tab.error; else tabError">
						<risk-characteristics-table [tab]="tab" [asOfDateSNP]="asOfDateSNP" tabId="eq.sleeve.characteristics"></risk-characteristics-table>
						<risk-characteristic-insights *componentId="'risk.equity.insights'; let res" [data]="res"></risk-characteristic-insights>
					</ng-container>
					<ng-template #tabError>
						<em class="not-applicable margin-standard" [dcrHTMLKey]="tab.error.errorCodes[0]">{{ tab.error.debugMessage }}</em>
					</ng-template>
				</content>
			</accordion-panel>
		</ng-container>
		<accordion-panel *ngIf="decompositionTabs.length > 0" [isCollapsed]="!(decompHeaderTab.displayConfig && decompHeaderTab.displayConfig.active)">
			<header><ng-container *ngTemplateOutlet="accordionHeaderContent; context: { tab: decompHeaderTab }"></ng-container></header>
			<content>
				<risk-decomposition-table
					tabId="eq.total.risk.decomposition"
					[decompositionTabs]="decompositionTabs"
					[totalPortfolioTab]="totalSumTab"
					[activeOnlyTab]="activeSumTab"
					[contributionTabs]="[data.tab['eq.total.risk.decomposition.contributions']]"
				>
				</risk-decomposition-table>
				<ac-disclosure>
					<ac-tpm-disclosure></ac-tpm-disclosure>
					<span dcrHTMLKey="EQUITY_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER">EQUITY_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER</span>
				</ac-disclosure>
			</content>
		</accordion-panel>
	</bfa-accordion>
</section>

<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
<ng-template #accordionHeaderContent let-tab="tab">
	<dl-tooltip-section-header [tab]="tab"></dl-tooltip-section-header>
</ng-template>
